import { useEffect } from 'react';

import SpinnerContainer from '../../SpinnerContainer';

type Props = {
  isPaymentValid: boolean;
  setHeadingText: (headingText: string) => void;
};

const CreditCardCharge = ({ isPaymentValid, setHeadingText }: Props) => {
  useEffect(() => {
    setHeadingText(isPaymentValid ? 'Payment successful' : 'Please wait while we process your payment');
  }, [isPaymentValid, setHeadingText]);

  return <div className="CreditCardCharge">{!isPaymentValid && <SpinnerContainer />}</div>;
};

export default CreditCardCharge;
